import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'notice-media-image-item',
  imports: [NgClass],
  template: `
    <div class="grid place-items-center rounded-t w-100 h-80! bg-neut-var-90">
      <img
        class="object-cover rounded-t h-80!"
        width="100"
        height="80"
        alt=""
        (click)="$event.stopPropagation(); !adminView && openLightbox.emit()"
        [ngClass]="{ 'hover:cursor-pointer': !adminView }"
        [src]="url" />
    </div>
  `
})
export class NoticeMediaImageItemComponent {
  @Input() adminView = false;
  @Input() url = '';
  @Output() openLightbox = new EventEmitter<void>();
}
